import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e7kxugs7rs: FaireBrandEntity = {
  token: "b_e7kxugs7rs",
  type: "brand",
  name: "StarryNYC",
  avatarUrl:
    "https://cdn.faire.com/fastly/5309ba3fff07ae08bae84ae11605767f87049366973e6d5154622e1b14ff4d03.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/97b269e188a97c356deca85cc9e52eac974426230e80bc0ec0ba37df90b835ce.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5309ba3fff07ae08bae84ae11605767f87049366973e6d5154622e1b14ff4d03.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/97b269e188a97c356deca85cc9e52eac974426230e80bc0ec0ba37df90b835ce.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 98,
  isInsider: true,
  description:
    "StarryNYC(Chic&Chic) was founded in 2012 in New York. \n\nSister Company : Lollipopdreams (Baby Clothing)\n\nFounded by jewelry designers with over 20 years of experience on Broadway NYC, \nour brand is built on a legacy of craftsmanship. \nBy partnering with trusted factories we’ve collaborated with for decades, \nwe provide top-tier jewelry at exceptional prices. \nOur high reorder rate is a testament to our quality\nwe guarantee you won’t be disappointed \n\n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:33.826Z",
    importedBy: "entity-db-cli",
  },
};
